@if (!noIcon) {
<icon type="exclamation-circle-fill"></icon>
}
<span class="visually-hidden">Warning:</span>
@if (html) {
<div [innerHTML]="html"></div>
}
<ng-content></ng-content>
